/**
 * Determine whether or not to perform actions that could have a high performance cost.
 */
export default function (): boolean {
	return window.innerWidth >= 1280 && !document.documentElement.classList.contains('no-animate');
}
